
import LazyLoad from './lazyload';
import GenericSticky from './generic-sticky.js';
import CardCarousel from './card-carousel.js';
import carCardInfoToggle from './generic-car-card';
import RecentlyViewedCars from './recently-viewed-cars';
import youtubeResponsifier from './_youtube-responsivity.js';

function init() {
  LazyLoad.init();
  GenericSticky.init();
  CardCarousel.init();
  RecentlyViewedCars.init();
  carCardInfoToggle();
  youtubeResponsifier();
}

export { init };
